import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=236d218c&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=236d218c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236d218c",
  null
  
)

export default component.exports